import { utcDate, userDate, addMinutes, OwaDate, startOfDay, isEqual } from 'owa-datetime';
import { getTimeZoneOffset } from 'owa-datetime-store';
import TxpStringFormatters from '../../schema/configSchema/TxpStringFormatters';
import { trace } from 'owa-trace';

// This method doesn't show the time part of dateTimeToParse if it's at midnight.
// So this shouldn't be used for scenarios like Flight cards.
export default function convertDateTimeToString(
    dateTimeToParse: string,
    isAccessible: boolean,
    txpStringFormatters: TxpStringFormatters
): string {
    let dateTimeString: string = '';
    let eventUtcDate: OwaDate;

    try {
        eventUtcDate = utcDate(dateTimeToParse);
    } catch {
        // owaDate can't create an owaDate from the string
        trace.error('Cannot create owaDate from datetime to be parsed: ' + dateTimeToParse);
        return null;
    }
    let eventDisplayDate: OwaDate;

    try {
        // We use a negation of the offset when creating an owaDate, otherwise the dates will be incorrect
        // See: owaDate's AdjustedDate
        const offset = getTimeZoneOffset(eventUtcDate);
        eventDisplayDate = userDate(addMinutes(eventUtcDate, -offset));
    } catch (e) {
        // If no offset exists we assume that the date is a UTC date
        eventDisplayDate = eventUtcDate;
    }

    const eventDateTimeString = eventDisplayDate.toString();
    // Is there a time part to this date? i.e. Is time at midnight?
    let midnight = startOfDay(eventDisplayDate);
    const midnightString = midnight.toString();

    if (isEqual(midnight, eventDisplayDate)) {
        if (!isAccessible) {
            dateTimeString = txpStringFormatters.formatWeekDayDate(midnightString);
        } else {
            dateTimeString = txpStringFormatters.formatWeekDayMonthDayYear(midnightString);
        }
    } else {
        if (!isAccessible) {
            dateTimeString = txpStringFormatters.formatWeekDayDateTime(eventDateTimeString);
        } else {
            dateTimeString = txpStringFormatters.formatMonthDayShortTime(eventDateTimeString);
        }
    }

    return dateTimeString;
}
